export var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["ACTIVE"] = "ACTIVE";
    SubscriptionStatus["SUSPENDED"] = "SUSPENDED";
    SubscriptionStatus["CANCELLED"] = "CANCELLED";
    SubscriptionStatus["PENDING_PAYMENT"] = "PENDING_PAYMENT";
})(SubscriptionStatus || (SubscriptionStatus = {}));
export var BillingCycle;
(function (BillingCycle) {
    BillingCycle["MONTHLY"] = "MONTHLY";
    BillingCycle["ANNUAL"] = "ANNUAL";
})(BillingCycle || (BillingCycle = {}));
export var ChargeInquiryStatus;
(function (ChargeInquiryStatus) {
    ChargeInquiryStatus["PENDING"] = "PENDING";
    ChargeInquiryStatus["APPROVED"] = "APPROVED";
    ChargeInquiryStatus["PROCESSING"] = "PROCESSING";
    ChargeInquiryStatus["COMPLETED"] = "COMPLETED";
    ChargeInquiryStatus["FAILED"] = "FAILED";
    ChargeInquiryStatus["CANCELLED"] = "CANCELLED";
})(ChargeInquiryStatus || (ChargeInquiryStatus = {}));
export var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["DRAFT"] = "DRAFT";
    InvoiceStatus["ISSUED"] = "ISSUED";
    InvoiceStatus["PAID"] = "PAID";
    InvoiceStatus["CANCELLED"] = "CANCELLED";
    InvoiceStatus["REFUNDED"] = "REFUNDED";
})(InvoiceStatus || (InvoiceStatus = {}));
export var SubscriptionBillingRunStatus;
(function (SubscriptionBillingRunStatus) {
    SubscriptionBillingRunStatus["RUNNING"] = "RUNNING";
    SubscriptionBillingRunStatus["COMPLETED"] = "COMPLETED";
})(SubscriptionBillingRunStatus || (SubscriptionBillingRunStatus = {}));
//# sourceMappingURL=subscription.types.js.map